<div class="content-container">
  <div class="section text-block divided">
    <h1 class="heading">{{locale.titleText}}</h1>
  </div>

  <div class="text-block course-list">
      <div class="course-item divided" *ngFor="let course of courses">
          <div class="columnar course-simple">
              <div>
                  <h4 class="dark">{{course.title}}</h4>
                  <p class="normal light">
                      {{course.code}}
                  </p>
              </div>
              <div class="cf course">
                  <h4 class="dark">{{course.institution}}</h4>
                  <div class="rating">
                      <star-rating [value]="course.rating"></star-rating>
                  </div>
                  <p class="normal input-button">
                      <button class="expando" [class.__expanded]="course.isExpanded" (click)="course.isExpanded = !course.isExpanded">View Details</button>
                  </p>
              </div>
          </div>
          <div class="columnar course-detailed" [class.__expanded]="course.isExpanded">
              <div class="overview">
                  <h4>{{locale.overviewHeaderText}}</h4>
                  <p class="normal light" [innerHTML]="course.overview | parseFormattedText"></p>
              </div>
          </div>
      </div>
  </div>
</div>



// WEBPACK FOOTER //
// ./src/app/components/finalise/list/finalise-list.component.html